import React from 'react'
import { createIntl, createIntlCache, FormattedMessage, injectIntl } from 'react-intl'

import locale from '../lngProvider/entries/pt-BR'

const cache = createIntlCache()
const intl = createIntl(
  {
    locale,
    messages: locale.messages,
    /**
     * In the past, internationalization was used incorrectly, leading to numerous errors in the console.
     * To enhance application performance and display only critical errors, console errors related to internationalization
     * have been temporarily disabled.
     */

    onError: () => {}
  },
  cache
)

export function getMessage(id, ...parameters) {
  const message = intl.formatMessage({ id })
  if (message) {
    if (Array.isArray(parameters) && parameters.length > 0) {
      let finalText = message
      for (const [i, element] of parameters.entries()) {
        finalText = finalText.replace(`[${i + 1}]`, element)
      }

      return finalText
    }

    return message
  }

  return ''
}

const InjectMassage = (props) => <FormattedMessage {...props} />
export default injectIntl(InjectMassage, {
  withRef: false
})
